<template>
  <div>

  <van-swipe @change="onChange">
    <van-pull-refresh v-model="isLoading" @refresh="hesap">
      <van-swipe-item>
        <van-field v-model="isim" label="İsim" disabled />
        <van-field v-model="kadi" label="Login" disabled />
        <van-field v-model="tel" type="number" label="Telefon" />
        <van-field v-model="posta" type="mail" label="E-Posta" />
        <van-field v-model="yetki" label="Yetki" disabled />
        <van-field v-model="defaultdepo" label="Depom" disabled />
        <van-field v-model="digit" type="text"  disabled  label="Token" />
        <van-field v-model="password" type="password" label="Password" />
        <van-button size="large" @click="update()" style="margin-bottom:10px"   type="default">GÜNCELLE</van-button>
        <van-button size="large" @click="cikis()" type="danger">GÜVENLİ ÇIKIŞ</van-button>
      </van-swipe-item>
    </van-pull-refresh>
    
    
    <!--<van-swipe-item>
           <van-field v-model="bolge" label="Bölge" disabled />
            <van-field v-model="yetki" label="Yetki" disabled />
            <van-field v-model="ekip" label="Ekip" disabled />
            <van-field v-model="digit" type="text"  disabled  label="Token" />
            <van-field v-model="digit" readonly center clearable placeholder="SMS">
              <template #button> <van-button size="small" type="primary">Yeni Token</van-button></template>
            </van-field>
           <van-field v-model="did" label="Aktif Depo" left-icon="points" readonly="true">
              <template v-if="ayar.yetki === 'el'" #button> <van-button size="small" type="default" @click="showPicker = true">Değiştir</van-button>
              </template>
            </van-field>
    </van-swipe-item>-->

    <!-- <van-swipe-item>
      <van-field v-model="mesaj" rows="3" autosize label="Hatırlatma" type="textarea" maxlength="100"
          placeholder="Metni buraya yazın" show-word-limit
      />
      <van-cell title="Hatırlatma Tarihi" :value="date" @click="calendar = true" />
       
      <van-button style="margin-top:40px" size="large" @click="ajanda()" type="dafault">HATIRLATMA EKLE</van-button>
      
    </van-swipe-item> -->

    <van-swipe-item>
            <van-grid style="margin-top:25px" :gutter="10" :column-num="3">
            <van-grid-item icon="photo-o" text="Teslim Formu" />
            <van-grid-item icon="photo-o" text="İade Formu" />
            <van-grid-item icon="photo-o" text="İptal Formu" />
            <van-grid-item icon="photo-o" text="Transfer Formu" />
            </van-grid>
    </van-swipe-item>


  <template #indicator>
    <div class="custom-indicator"></div>
  </template>
</van-swipe>




      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="depo" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
        
         <div style="height:100px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
<van-calendar v-model="calendar" @confirm="tarihsec" /> 
  <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { decode} from 'js-base64';

export default {
  data() {
    return {
      ayar:this.$request.ayar(),
      bolge:'',
      yetki:'',
      posta:'',
      tel: '',
      kadi: '',
      isim:'',
      ekip:'',
      digit:this.$request.ayar().tkn.egz,
      password: '',
      depo:[], // depo listesi için yapılmıştı, depo değiştir seçeneği
      //defaultdepo:decode(this.$request.ayar().genel.d),
      showPicker:false,
      active:'Hesabım',
     // did:this.$request.did(), // sadece yukarı basmak için
      isLoading: false,
      show:false,
      mesaj:'',
      calendar : false,
      date: '',
    };
  },
  created(){
    //this.depogetir()
    this.hesap()

  },
  methods: {
      cikis(){
         this.show = true
          this.$helper.logout();
      },       
        hesap(){
          this.show = true;
          //setTimeout(() => {
          this.$request.get("servis/hesap/"+this.ayar.firmaid+"/"+this.ayar.kid)
          .then(res => {
              this.bolge = res.results[0].bolge
              this.yetki = res.results[0].tip
              this.isim = res.results[0].isim
              this.tel = res.results[0].tel
              this.posta = res.results[0].eposta
              this.password = res.results[0].pass
              this.kadi = res.results[0].kadi
              this.ekip = res.results[0].ekip
          })
          this.isLoading = false;
          this.show=false
          //}, 500);
        },
        update(){
          this.show = true;

            let newPost = {
              id : this.ayar.kid,
              telefon : this.tel,
              posta : this.posta,
              pass : this.password
            }
            this.$request.post("updateUser/", newPost)
            .then (res => {
                this.hesap();
            })
        },
        // ajanda(){
        //   this.show = true;
        //     let newPost = {
        //       kodu : this.ayar.kid,
        //       firma : this.ayar.firmaid,
        //       alias: this.mesaj,
        //       tarih: this.date
        //     }
        //     this.$request.post("ajanda/", newPost)
        //     .then (res => {
        //       Toast('Eklendi');
        //         this.show = false
        //     })
        // },        

        // depogetir(){this.$request.get("depo/"+this.ayar.firmaid).then(res => { 
        //   for (let i = 0; i < res.results.length; i++) {this.depo.push(res.results[i].alias);}
        // })},
        // onConfirm(value) {
        //   localStorage.setItem('did', value)
        //   this.did = value //this.$request.did();
        //   Toast.loading({ message: 'Depo Değişiyor', forbidClick: true, loadingType: 'spinner', });
        //   this.showPicker = false;
        // },
        // onChange(index) {
        //   //this.active = index+1;
        // },
        // formatDate(date) {
        //   return `${date.getFullYear() + 1}/${date.getMonth()}/${date.getDate()}`;
        // },        
        // tarihsec(date) {
        //   this.show = false;
        //   this.date = this.formatDate(date);
        // },

  },
};
</script>


// WEBPACK FOOTER //
// src/components/hesap.vue